import React from 'react';
import './Rain.Widget.css';

export default function RainWidget({ size = 32, values }) {
  const [rainFall = '-', rainFallTime = '-'] = values;
  const unitTime = 'мин';
  const unitParam = 'мм';
  return (
    <>
      <div className="rain-widget-current">
        <RainIcon size={size} color="#3b82f6" />
        <span className="rain-widget-current-value">
          <p>{rainFall}</p>
          <p>{unitParam}</p>
        </span>
      </div>
      <div className="rain-widget-duration">
        <p>
          Длительность
        </p>
        <p>
          {`${rainFallTime} ${unitTime}`}
        </p>
      </div>
    </>
  );
}

function RainIcon({ size, color }) {
  return (
    <div className="rain-widget-icon">
      <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path xmlns="http://www.w3.org/2000/svg" d="M14,18.4c-0.8,1.3-1.5,2.7-2.3,4c-0.3,0.6-1.2,0.1-0.9-0.5c0.8-1.3,1.5-2.7,2.3-4C13.4,17.3,14.3,17.8,14,18.4z   M9.3,17.7c-0.3-0.1-0.6-0.1-0.7,0.2c-0.4,0.6-0.7,1.2-1.1,1.8c-0.1,0.2-0.1,0.6,0.2,0.7c0.3,0.1,0.6,0.1,0.7-0.2  c0.4-0.6,0.7-1.2,1.1-1.8C9.6,18.2,9.6,17.8,9.3,17.7z M18.3,17.6c-0.3-0.1-0.6-0.1-0.7,0.2c-0.4,0.6-0.7,1.3-1.1,1.9  c-0.1,0.2-0.1,0.6,0.2,0.7c0.3,0.1,0.6,0.1,0.7-0.2c0.4-0.6,0.7-1.3,1.1-1.9C18.6,18.1,18.6,17.7,18.3,17.6z M21,10c0-2.2-1.8-4-4-4  c-0.4,0-0.8,0.1-1.1,0.2c-1-1.3-2.6-2.2-4.4-2.2C8.5,4,6,6.5,6,9.5C6,9.7,6,9.8,6,10h0c-1.7,0-3,1.3-3,3c0,1.6,1.3,3,3,3h15  c1.7,0,3-1.4,3-3C24,11.3,22.7,10,21,10z" />
      </svg>
    </div>
  );
}
